import { renderTextWithCitations } from "@/components/ArticleText";
import "./LvmhArticle.css";

export const LvmhPrelude = ({ section }) => <section className="lvmh-prelude shell" aria-labelledby="lvmh-prelude-heading" data-testid="lvmh-executive-summary">
  <div className="lvmh-prelude-heading"><span aria-hidden="true">—</span><h2 id="lvmh-prelude-heading" data-testid="lvmh-executive-summary-heading">{section.title}</h2></div>
  <div className="lvmh-prelude-copy">{section.blocks.map((block, index) => <p key={index} data-testid={`lvmh-executive-summary-paragraph-${index + 1}`}>{renderTextWithCitations(block.text, `lvmh-executive-summary-${index + 1}`)}</p>)}</div>
</section>;

export const LvmhAtAGlance = ({ content }) => <section className="lvmh-at-a-glance shell" aria-labelledby="lvmh-at-a-glance-heading" data-testid="lvmh-at-a-glance">
  <header><p>Research brief</p><h2 id="lvmh-at-a-glance-heading" data-testid="lvmh-at-a-glance-heading">At a Glance</h2></header>
  <div className="lvmh-at-a-glance-grid">
    {content.items.map((item, index) => <div className={item.sequence ? "is-sequence" : ""} key={item.label} data-testid={`lvmh-at-a-glance-item-${index + 1}`}>
      <span data-testid={`lvmh-at-a-glance-label-${index + 1}`}>{item.label}</span>
      {item.sequence
        ? <ol aria-label={item.label} data-testid="lvmh-value-mechanism">{item.value.split(" → ").map((step, stepIndex) => <li key={step}><b>{step}</b>{stepIndex < 3 && <i aria-hidden="true">↓</i>}</li>)}</ol>
        : <p data-testid={`lvmh-at-a-glance-value-${index + 1}`}>{item.value}</p>}
    </div>)}
  </div>
</section>;

export const ArticleDataTable = ({ block, testId }) => <figure className="lvmh-data-table-figure" data-testid={testId}>
  <figcaption data-testid={`${testId}-caption`}>{block.caption}</figcaption>
  <div className="lvmh-data-table-wrap" tabIndex="0" role="region" aria-label={block.caption} data-testid={`${testId}-scroll-region`}>
    <table><thead><tr>{block.headers.map((header) => <th scope="col" key={header}>{header}</th>)}</tr></thead><tbody>
      {block.rows.map((row, rowIndex) => <tr key={`${row[0]}-${rowIndex}`}>{row.map((cell, cellIndex) => <td key={cellIndex} data-label={block.headers[cellIndex]}>{cell}</td>)}</tr>)}
    </tbody></table>
  </div>
</figure>;

export const SourceHierarchy = ({ block, testId }) => <ArticleDataTable
  testId={testId}
  block={{
    caption: "Primary references and source hierarchy",
    headers: block.headers,
    rows: block.rows.map((row, index) => [...row.slice(0, 3), <a href={row[3]} target="_blank" rel="noreferrer" data-testid={`${testId}-source-link-${index + 1}`}>{row[3]}</a>]),
  }}
/>;

export const ChartDownloads = ({ block, testId }) => <ul className="lvmh-chart-downloads" data-testid={testId}>
  {block.items.map((item, index) => <li key={item.label}><a href={item.href} download data-testid={`${testId}-link-${index + 1}`}>{item.label}<span aria-hidden="true">↓</span></a></li>)}
</ul>;

export const SourceNote = ({ block, testId }) => <p className="lvmh-source-note" data-testid={testId}>{renderTextWithCitations(block.text, testId)}</p>;